import { isPlatformBrowser } from '@angular/common';
import { APP_ID, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter } from 'rxjs/operators';
import { UserService } from 'src/app/shared/services/user/user.service';
declare var $: any;

@Component({
  selector: 'app-apprentice-application',
  templateUrl: './apprentice-application.component.html',
  styleUrls: ['./apprentice-application.component.scss']
})
export class ApprenticeApplicationComponent implements OnInit {
  public checkSubmitApplication = false;
  public person = JSON.parse(localStorage.getItem('person'));
  public token = localStorage.getItem('token');
  public value: number = 0;
  public arrow: boolean = false;
  public isRenewalApplication = false;
  public currentApplicationDetails: any;

  constructor(private userService: UserService, private spinner: NgxSpinnerService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string) {
    this.router.events.pipe(
      filter((event: RouterEvent) => event instanceof NavigationEnd)
    ).subscribe((data: any) => {
      this.activatedTab();
    });

    let interval = setInterval(() => {
      this.value = this.value + Math.floor(Math.random() * 10) + 1;
      if (this.value >= 100) {
        this.value = 100;
        clearInterval(interval);
      }
    }, 2000);
  }

  ngOnInit() {
    this.userService.setCurrentApprenticeApplication();
    this.currentApplicationDetails = this.userService.getCurrentApprentice();
    if (this.currentApplicationDetails.isRenewLicensingApplication === true) {
      this.isRenewalApplication = true;
    } else {
      this.isRenewalApplication = false;
    }
    if (this.currentApplicationDetails.isLicensingApplicationSubmitted === true && this.currentApplicationDetails.isMedicalSubmitted === true && this.currentApplicationDetails.isReferencesSubmitted === true) {
      this.checkSubmitApplication = true;
    }
    this.router.navigate(['apprentice-application/details']);
  }

  public progessbarHandler() {
    $('.next').click(function () {
      var nextId = $(this).parents('.tab-pane').next().attr("id");
      $('[href=#' + nextId + ']').tab('show');
      return false;
    });
    $('.back').click(function () {
      var prevId = $(this).parents('.tab-pane').prev().attr("id");
      $('[href=#' + prevId + ']').tab('show');
      return false;
    });
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      var step = $(e.target).data('step');
      var percent = (parseInt(step) / 4) * 100;
      $('.progress-bar').css({ width: percent + '%' });
      $('.progress-bar').text('Step ' + step + ' of 4');
    });
  }

  onActivate(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, 0);
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 16);
    }
  }

  activatedTab() {
    $('.nav-link').removeClass('active');
    if (this.router.url.match('/details')) {
      $('#details-tab').addClass('active');
      var targetToScroll = <HTMLElement>document.getElementById("details-tab");
      if (targetToScroll) {
        targetToScroll.scrollIntoView();
      }
    } else if (this.router.url.match('/employment')) {
      $('#employment-tab').addClass('active');
      var targetToScroll = <HTMLElement>document.getElementById("employment-tab");
      if (targetToScroll) {
        targetToScroll.scrollIntoView();
      }
    } else if (this.router.url.match('/next-steps')) {
      $('#next-steps-tab').addClass('active');
      var targetToScroll = <HTMLElement>document.getElementById("next-steps-tab");
      if (targetToScroll) {
        targetToScroll.scrollIntoView();
      }
    } else if (this.router.url.match('/fees')) {
      $('#fees-tab').addClass('active');
      var targetToScroll = <HTMLElement>document.getElementById("fees-tab");
      if (targetToScroll) {
        targetToScroll.scrollIntoView();
      }
    }
  }

  public saveTab(tab) {
    localStorage.setItem('tab', tab);
    var valueChanges = JSON.parse(localStorage.getItem('valueChanges'));
    if (this.checkSubmitApplication === true) {
      this.router.navigate(['apprentice-application/' + tab]);
    } else if (valueChanges === true) {
      if (this.router.url.match('/details')) {
        $('#postDetailsModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else if (this.router.url.match('/employment')) {
        $('#postEmploymentConditionsModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else if (this.router.url.match('/next-steps')) {
        $('#postNextStepsModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else if (this.router.url.match('/fees')) {
        $('#postFeesModal').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    } else {
      this.router.navigate(['apprentice-application/' + tab]);
    }
  }
}
